<template>
  <el-container class="full-content" style="background-color:#27BE7D;">
    <el-main class="flex-col-center">
      <div class="login-center flex-row-start">
        <div class="login-left-bg flex-col-center"><img :src="$Image('sginInBG.png')" alt=""></div>
        <div class="login-right">
          <div class="login-right-welcome">{{$t('Welcome to FamiKit')}}</div>
          <div class="login-box signUp-box">
            <div style="margin-top:39px;width:100%;" class="flex-col-center">
              <div class="loginInputBox">
                <el-input class="login-input flex-row-center" :placeholder="$t('Email')" v-model="emailValue" tabindex="1"></el-input>
                <img class="email" :src="$Image('ico_eml.png')" alt="">
              </div>
              <div class="loginInputBox">
                <el-input class="login-input flex-row-center" style="margin-top:20px;" :placeholder="$t('Password')" :type="isShowPassword ?   'text' : 'password'" v-model="password" tabindex="2"></el-input>
                  <img class="password" :src="$Image('ico_psw.png')" alt="">
                  <img class="hide1" v-if="!isShowPassword" @click="onShowPassword" :src="$Image('ico_hide.png')" alt="">
                  <img class="hide2" v-if="isShowPassword" @click="onShowPassword" :src="$Image('ico_disp.png')" alt="">
              </div>
              <div class="loginInputBox">
                <el-input class="login-input flex-row-center" style="margin-top:20px;" :placeholder="$t('Repeat Password')"   :type="isShowRepeatPassword ? 'text' : 'password'" v-model="repeatPassword" tabindex="3"></el-input>
                <img class="password" :src="$Image('ico_psw.png')" alt="">
                <img class="hide1" v-if="!isShowRepeatPassword" @click="onShowRepeatPassword" :src="$Image('ico_hide.png')" alt="">
                <img class="hide2" v-if="isShowRepeatPassword" @click="onShowRepeatPassword" :src="$Image('ico_disp.png')" alt="">
              </div>
              <div class="flex-row-center signup-mobile-text">
                <span style="color:#888888;width:100%">
                  <el-checkbox v-model="radio" style="margin-right:10px;"></el-checkbox>
                  {{$t('I agree')}}
                  <span class="toSingnUp" style="font-size:16px;margin:0 10px;" @click="onAgreementUse">{{$t('User agreement')}}</span>
                  {{$t('and')}}
                  <span class="toSingnUp" style="font-size:16px;margin-left:10px;" @click="onPrivacyUse">{{$t('Privacy policy')}}</span>
                </span>
              </div>
              <div style="width:100%;height:16px;color:#a94442;font-size:14px;margin-top:10px;text-align:center;" v-if="error">{{errorType}}</div>
              <div class="errorStyle" v-if="!error && onClickSignUp" style="margin-top:10px;color:#434343;font-size:18px;">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </div>
          <el-button class="normalBtn sign-btn" style="width:190px;height:50px;font-size:20px;" @click="onRegister">{{$t('Register')}}</el-button>
          <div class="no-account">
            {{$t('Existing account?')}}
            <span @click="onSignin">{{$t('Sign in')}}</span>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="login-footer flex-col-center">
      <span>{{$t('Copyright @ 2020, Famikit.com. All rights reserved.')}}</span>
    </el-footer>
  </el-container>
</template>
<script>
import JSEncrypt from 'jsencrypt'
export default {
  name: 'Register',
  data () {
    return {
      emailValue: '',
      password: '',
      repeatPassword: '',
      radio: false,
      onClickSignUp: false,
      error: false,
      mobile: '',
      isShowPassword: false,
      isShowRepeatPassword: false,
      errorType: ''
    }
  },
  methods: {
    // 邮箱验证
    onUsername () {
      let Reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      if (this.emailValue === '') {
        this.error = true
        this.errorType = this.$t('Email cannot be blank.')
      } else if (!Reg.test(this.emailValue)) {
        this.error = true
        this.errorType = this.$t('Please enter a valid email address')
      } else {
        this.error = false
      }
    },
    // 一次输入密码验证
    onPassword () {
      this.onUsername()
      if (this.password === '') {
        if (!this.error) {
          this.error = true
          this.errorType = this.$t('Password cannot be blank.')
        }
      } else {
        if (!this.error) {
          this.error = false
        }
      }
    },
    // 二次密码验证
    onconfirm () {
      this.onPassword()
      if (this.repeatPassword === '') {
        if (!this.error) {
          this.error = true
          this.errorType = this.$t('Repeat Password cannot be blank.')
        }
      } else if (this.repeatPassword !== this.password) {
        if (!this.error) {
          this.error = true
          this.errorType = this.$t('The two passwords you entered do not match.')
        }
      } else {
        if (!this.error) {
          this.error = false
        }
      }
    },
    // 跳转登录
    onSignin () {
      this.$router.push({name: 'Login'})
    },
    onShowPassword () {
      this.isShowPassword = !this.isShowPassword
    },
    onShowRepeatPassword () {
      this.isShowRepeatPassword = !this.isShowRepeatPassword
    },
    // 注册按钮
    async onRegister () {
      if (!this.radio) {
        this.error = true
        this.errorType = this.$t('Please read and agree to the terms of service first.')
        return
      }
      this.onconfirm()
      this.onClickSignUp = true
      if (!this.error) {
        const stamp = await this.$http.get('/GetLoginStamp')
        console.log(stamp)
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC51ywBVBF899Rt6brFw1x4jM8b
  /VzqEq+sqK2m1CYPZJEJuHvJWeNjksZLSf9olOU1cu48dIdVNHUGa0vVZfTggP0d
  GeCtKDbLiwzM0jEBy7kbPhDT1wCB/nZCY1hxWBhd7o3vnJX8pGsEvytaw+nSVkLm
  xHsnQpbgspUG8cMEmwIDAQAB
  -----END PUBLIC KEY-----`)
        const encryptedpwd = encrypt.encrypt(stamp.data + this.password)
        let result = await this.$http.post('/Register', {
          username: this.emailValue,
          password: encryptedpwd,
          email: this.emailValue
        })
        switch (result.data.code) {
          case 0:
            // 注册成功跳转登录
            this.$router.push({name: 'Login'})
            break
          case -5:
            this.error = true
            this.errorType = this.$t('Username already exists.')
            break
          default:
            this.error = true
            this.errorType = this.$t('unexpected error.')
        }
        this.onClickSignUp = false
        console.log(result)
      } else {
        this.onClickSignUp = false
      }
    },
    onAgreementUse () {
      window.location.href = 'https://famikit.com/terms.html'
    },
    onPrivacyUse () {
      window.location.href = 'https://famikit.com/privacy.html'
    }
  }
}
</script>
<style lang="scss">
  .login-center{
    width: 63%;
    // height: 78%;
    background-color: #ffffff;
    border-radius: 20px;
  }
  .login-footer{
    font-family: 'Nunito-Light';
    font-size: 14px;
    color: #ffffff;
  }
  .login-left-bg{
    width:45%;
    height:100%;
    border-top-left-radius:20px;
    border-bottom-left-radius:20px;
    background-color:#edf5f2;
    img{
        width: auto;height: auto;max-width: 100%;max-height: 100%;
      }
  }
  .login-right{
    width:55%;
    height:100%;
    padding:20px;
    box-sizing:border-box;
    .login-right-welcome{
      margin-top:10%;
      font-family: Nunito Bold;
      font-size: 36px;
      color: #404040;
    }
    .sign-btn{
      margin-top:12%;
    }
    .no-account{
      margin-top:20px;
      margin-bottom: 30px;
      font-size:16px;
      color:#888;
      span{
        color:#2bcf88;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
.signup-mobile-text{
  width:76%;
  margin-top:18px;
  flex-wrap: wrap!important;
  box-sizing: border-box;
  justify-content: flex-start;
}
.toSingnUp{
  color: #2bcf88;
  text-decoration: underline;
  cursor: pointer;
}
@media (max-width: 1024px){
  .login-center{
    // height: 66%;
    margin-top: 130px;
     .login-left-bg {
      display: none !important;
    }
  }
  .login-right{
    width: 100%;
    .login-right-welcome{
      font-size: 30px;
      margin-top:8%;
    }
    .sign-btn{
      margin-top:30px;
    }
    .no-account{
      margin-top:30px;
    }
  }
}
@media (max-width: 768px){
  .login-center{
    // height: 66%;
    width: 80%;
  }
  .signup-mobile-text{
    width:87%;
  }
}
@media (max-width: 540px){
  .login-center{
    // height: 80%;
    width: 90%;
    margin-top: 100px;
  }
}
@media (max-width: 375px){
   .login-center{
    // height: 88%;
  }
}
@media (max-width: 320px){
  .login-right{
    width: 100%;
    .login-right-welcome{
      font-size: 20px;
    }
    .no-account{
      margin-top:30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Register.vue